import React from "react";
import ExamplePage from "./pages/ExamplePage";
import Home from "./pages/home";
import FeaturesBusiness from "./pages/Features/Business";
import FeaturesConsumer from "./pages/Features/Consumer";
import UseCaseRestaurant from "./pages/UseCase/Restaurant";
import UseCaseDining from "./pages/UseCase/DiningAutomation";
import UseCaseHotel from "./pages/UseCase/Hotel";
import UseCaseRetail from "./pages/UseCase/RetailStore";
import UseCaseMovie from "./pages/UseCase/MovieTheatre";
import UseCaseCasino from "./pages/UseCase/Casino";
import UseCaseKiosk from "./pages/UseCase/Kiosk";
import FlashBot from "./pages/Robots/FlashBot";
import PromoBot from "./pages/Robots/PromoBot";
import PuduBot from "./pages/Robots/PuduBot";
import Faq from "./pages/Faq";
import MerchantService from "./pages/MerchantService";
import BrowseByUseCases from "./pages/MerchantService/BrowseByUseCases";

import IAcceptPaymentsAtTheCounter from './pages/MerchantService/useCases/iAcceptPaymentsAtTheCounter';
import IAcceptPaymentsAwayFromACounter from './pages/MerchantService/useCases/iAcceptPaymentsAwayFromACounter';
import IAcceptPaymentsOnTheRoad from './pages/MerchantService/useCases/iAcceptPaymentsOnTheRoad';
import IInvoiceMyCustomers from './pages/MerchantService/useCases/iInvoiceMyCustomers';
import IHaveAnOnlineStore from './pages/MerchantService/useCases/iHaveAnOnlineStore';
import IKeyInPaymentsOnBehalfOfMyCustomers from './pages/MerchantService/useCases/iKeyInPaymentsOnBehalfOfMyCustomers';
import IChargeAFixedRecurringFee from './pages/MerchantService/useCases/iChargeAFixedRecurringFee';
import ImBuildingACustomWebsiteOrSoftwareApplication from './pages/MerchantService/useCases/imBuildingACustomWebsiteOrSoftwareApplication';
import IDontSeeMyUseCaseHere from './pages/MerchantService/useCases/iDontSeeMyUseCaseHere';
import ServiceRate from "./pages/MerchantService/ServiceRate";
import Industry0To10 from "./pages/MerchantService/industrySale/industry-0-10k";
import AutoShop from "./pages/MerchantService/industrySale/industry-10-50k/auto_shop.js";
import Cannabis from "./pages/MerchantService/industrySale/industry-10-50k/cannabis.js";
import CarWash from "./pages/MerchantService/industrySale/industry-10-50k/car_wash.js";
import Charities from "./pages/MerchantService/industrySale/industry-10-50k/charities.js";
import Ecommerce from "./pages/MerchantService/industrySale/industry-10-50k/ecommerce.js";
import GasStation from "./pages/MerchantService/industrySale/industry-10-50k/gas_station.js";
import Grocery from "./pages/MerchantService/industrySale/industry-10-50k/grocery.js";
import Invoicing from "./pages/MerchantService/industrySale/industry-10-50k/invoicing.js";
import Medical from "./pages/MerchantService/industrySale/industry-10-50k/medical.js";
import RecurringFees from "./pages/MerchantService/industrySale/industry-10-50k/recurring_fees.js";
import Restaurants from "./pages/MerchantService/industrySale/industry-10-50k/restaurants.js";
import Retail from "./pages/MerchantService/industrySale/industry-10-50k/retail.js";
import Salons from "./pages/MerchantService/industrySale/industry-10-50k/salons.js";
import Services from "./pages/MerchantService/industrySale/industry-10-50k/services.js";
import Taxi from "./pages/MerchantService/industrySale/industry-10-50k/taxi.js";
import VarietyStores from "./pages/MerchantService/industrySale/industry-10-50k/variety_stores.js";


import Industry10To50 from "./pages/MerchantService/industrySale/industry-10-50k";
import Industry50To100 from "./pages/MerchantService/industrySale/industry-50-100k";
import Industry100To250 from "./pages/MerchantService/industrySale/industry-100-250k/index.js";
import Industry250To500 from "./pages/MerchantService/industrySale/industry-250-500k";
import Industry500 from "./pages/MerchantService/industrySale/industry-500k";

import CloverFlex from "./pages/PosDevices/CloverFlex";
import CloverMini from "./pages/PosDevices/CloverMini";
import CloverStationDuo from "./pages/PosDevices/CloverStationDuo";
import CloverStationSolo from "./pages/PosDevices/CloverStationSolo";
import KitchenDisplaySystem from "./pages/PosDevices/KitchenDisplaySystem";
import SelfServiceKiosk from "./pages/PosDevices/SelfServiceKiosk";
import SoftwareSolution from "./pages/SoftwareSolution";
import KioskSoftwareSolution from "./pages/UseCase/Kiosk/softwareSolution";
import AcquireNewCustomers from "./pages/AcquireNewCustomers";
import OwnYourOnlineBrand from "./pages/OwnYourOnlineBrand";
import BellaBot from "./pages/Robots/BellaBot";
import AutomateOrderProcess from "./pages/AutomateOrderProcess";
import HardwareSolution from "./pages/HardwareSolution";
import AboutUs from "./pages/AboutUs";
import Pricing from "./pages/Pricing";
import BlogPage from "./pages/BlogPage";
import BlogPost from "./pages/BlogPost";
import GrantsLandingPage from "./pages/GrantsLandingPage";
import GoDigital from "./pages/GoDigital";
import TechUp from "./pages/TechUp";
import RequestDemoPage from "./pages/RequestDemo/index";
import ContactUs from "./pages/ContactUs";
import SignUp from "./pages/SignUp";
import SiteMap from "./pages/SiteMap";
import AutonomousDisinfectionRobot from "./pages/Robots/AutonomousDisinfectionRobot";
import TermsConditions from "./pages/TermConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Careers from "./pages/Careers";
import Header from "../Header";
import Footer from "../Footer";
import { Router, Switch, Route } from "react-router-dom";
import "./Main.css";
import ScrollToTop from "components/ScrollToTop";
import MetaTags from "react-meta-tags";
import locales from "../../locales";
import { useSelector, useDispatch } from "react-redux";
import { IntlProvider } from "react-intl";
import history from "app/history";
import _ from "lodash";
import qs from "query-string";
import { changeLanguage } from "slices/settings";
import { ShowTop } from "util/helper";

import CloverApplication from "./pages/CloverApplication"; 
import CommercialEquipmentLeasing from "./pages/CommercialEquipment"; 


const Main = (props) => {
  const dispatch = useDispatch();
  const { data } = props;
  const queryLan = qs.parse(window?.location.search).lan;
  if (queryLan) {
    dispatch(changeLanguage({ language: queryLan }));
  }
  const lan = useSelector((state) => state?.settings?.lan ?? "en");

  const ShowMetaTag = (page) => {
    return (
      <MetaTags>
        <title>{metaTag[page].title}</title>
      </MetaTags>
    );
  };
  const routes = [
    { path: 'auto_shop', component: AutoShop },
    { path: 'cannabis', component: Cannabis },
    { path: 'car_wash', component: CarWash },
    { path: 'charities', component: Charities },
    { path: 'ecommerce', component: Ecommerce },
    { path: 'gas_station', component: GasStation },
    { path: 'grocery', component: Grocery },
    { path: 'invoicing', component: Invoicing },
    { path: 'medical', component: Medical },
    { path: 'recurring_fees', component: RecurringFees },
    { path: 'restaurants', component: Restaurants },
    { path: 'retail', component: Retail },
    { path: 'salons', component: Salons },
    { path: 'services', component: Services },
    { path: 'taxi', component: Taxi },
    { path: 'variety_stores', component: VarietyStores },
  ];
  const industryRanges = [
    'industry-0-10k',
    'industry-10-50k',
    'industry-50-100k',
    'industry-100-250k',
    'industry-250-500k',
    'industry-500k',
  ];
  return (
    <>
      <MetaTags>
        <link rel="canonical" href="https://www.goopter.com/" />
        <meta name="author" content="Goopter" />
        <meta name="robots" content="index, follow" />
      </MetaTags>
      <Router history={history}>
        <IntlProvider
          locale={queryLan || lan}
          messages={locales.getIntlMessages(queryLan || lan)}
        >
          <ShowTop />
          <Header menu={data.menu} />
          <div className="main-page">
            <Switch>
              <Route exact path="/">
                {ShowMetaTag("Home")}
                <Home />
              </Route>
              <Route path="/features-business">
                {ShowMetaTag("FeaturesBusiness")}
                <FeaturesBusiness />
              </Route>
              <Route path="/features-consumer">
                {ShowMetaTag("FeaturesConsumer")}
                <FeaturesConsumer />
              </Route>
              <Route path="/use-case-restaurant-ordering-solution">
                {ShowMetaTag("UseCaseRestaurant")}
                <UseCaseRestaurant />
              </Route>
              <Route path="/use-case-dining-automation">
                {ShowMetaTag("UseCaseDining")}
                <UseCaseDining />
              </Route>
              <Route path="/use-case-hotel-service-automation">
                {ShowMetaTag("UseCaseHotel")}
                <UseCaseHotel />
              </Route>
              <Route path="/use-case-retail-store-automation">
                {ShowMetaTag("UseCaseRetail")}
                <UseCaseRetail />
              </Route>
              <Route path="/use-case-movie-theatre-ordering">
                {ShowMetaTag("UseCaseMovie")}
                <UseCaseMovie />
              </Route>
              <Route path="/use-case-casino-food-drink-automation">
                {ShowMetaTag("UseCaseCasino")}
                <UseCaseCasino />
              </Route>
              <Route path="/use-case-self-order-kiosk">
                {ShowMetaTag("UseCaseKiosk")}
                <UseCaseKiosk />
              </Route>
              <Route path="/flashbot-building-delivery-robot">
                {ShowMetaTag("FlashBot")}
                <FlashBot />
              </Route>
              <Route path="/promobot-promotional-delivery-robot">
                {ShowMetaTag("PromoBot")}
                <PromoBot />
              </Route>
              <Route path="/pudubot-food-delivery-robot">
                {ShowMetaTag("PuduBot")}
                <PuduBot />
              </Route>
              <Route path="/faq">
                {ShowMetaTag("Faq")}
                <Faq
                  faqpost_en={data.faqpost_en}
                  faqpost_zh={data.faqpost_zh}
                />
              </Route>
              <Route path="/grants">
                {ShowMetaTag("GrantsLandingPage")}
                <GrantsLandingPage />
              </Route>
              <Route path="/merchant-service">
                {ShowMetaTag("MerchantService")}
                <MerchantService />
              </Route>
              <Route path="/browse-by-use-cases">
                {ShowMetaTag("BrowseByUseCases")}
                <BrowseByUseCases />
              </Route>
              <Route path="/browse_by_use_case_data_i_accept_payments_at_the_counter">
                {ShowMetaTag("BrowseByUseCases")}
                <IAcceptPaymentsAtTheCounter />
              </Route>
              <Route path="/browse_by_use_case_data_i_accept_payments_away_from_a_counter">
                {ShowMetaTag("BrowseByUseCases")}
                <IAcceptPaymentsAwayFromACounter />
              </Route>
              <Route path="/browse_by_use_case_data_i_accept_payments_on_the_road">
                {ShowMetaTag("BrowseByUseCases")}
                <IAcceptPaymentsOnTheRoad />
              </Route>
              <Route path="/browse_by_use_case_data_i_invoice_my_customers">
                {ShowMetaTag("BrowseByUseCases")}
                <IInvoiceMyCustomers />
              </Route>
              <Route path="/browse_by_use_case_data_i_have_an_online_store">
                {ShowMetaTag("BrowseByUseCases")}
                <IHaveAnOnlineStore />
              </Route>
              <Route path="/browse_by_use_case_data_i_key_in_payments_on_behalf_of_my_customers">
                {ShowMetaTag("BrowseByUseCases")}
                <IKeyInPaymentsOnBehalfOfMyCustomers />
              </Route>
              <Route path="/browse_by_use_case_data_i_charge_a_fixed_recurring_fee">
                {ShowMetaTag("BrowseByUseCases")}
                <IChargeAFixedRecurringFee />
              </Route>
              <Route path="/browse_by_use_case_data_im_building_a_custom_website_or_software_application">
                {ShowMetaTag("BrowseByUseCases")}
                <ImBuildingACustomWebsiteOrSoftwareApplication />
              </Route>
              {/* <Route path="/browse_by_use_case_data_i_dont_see_my_use_case_here">
                {ShowMetaTag("BrowseByUseCases")}
                <IDontSeeMyUseCaseHere />
              </Route> */}

              <Route exact path="/service-rate">
                {ShowMetaTag("ServiceRate")}
                <ServiceRate />
              </Route>
              <Route exact path="/service-rate/industry-0-10k">
                {ShowMetaTag("ServiceRate")}
                <Industry0To10 />
              </Route>
              <Route exact path="/service-rate/industry-10-50k">
                {ShowMetaTag("ServiceRate")}
                <Industry10To50 />
              </Route>
              <Route exact path="/service-rate/industry-50-100k">
                {ShowMetaTag("ServiceRate")}
                <Industry50To100 />
              </Route>
              <Route exact path="/service-rate/industry-100-250k">
                {ShowMetaTag("ServiceRate")}
                <Industry100To250 />
              </Route>
              <Route exact path="/service-rate/industry-250-500k">
                {ShowMetaTag("ServiceRate")}
                <Industry250To500 />
              </Route>
              <Route exact path="/service-rate/industry-500k">
                {ShowMetaTag("ServiceRate")}
                <Industry500 />
              </Route>
              <Route exact path="/service-rate/request-a-demo">
                {ShowMetaTag("ServiceRate")}
                <RequestDemoPage />
              </Route>


              {industryRanges.map((range) => (
                routes.map(({ path, component: Component }) => (
                  <Route path={`/service-rate/${range}/${path}`} key={`${range}/${path}`}>
                    {ShowMetaTag("ServiceRate")}
                    <Component />
                  </Route>
                ))
              ))}





              <Route path="/pos-device-clover-flex">
                {ShowMetaTag("CloverFlex")}
                <CloverFlex />
              </Route>

              <Route path="/pos-device-clover-mini">
                {ShowMetaTag("CloverMini")}
                <CloverMini />
              </Route>
              <Route path="/pos-device-clover-station-duo">
                {ShowMetaTag("CloverStationDuo")}
                <CloverStationDuo />
              </Route>
              <Route path="/pos-device-clover-station-solo">
                {ShowMetaTag("CloverStationSolo")}
                <CloverStationSolo />
              </Route>
              <Route path="/pos-device-kitchen-display-system">
                {ShowMetaTag("KitchenDisplaySystem")}
                <KitchenDisplaySystem />
              </Route>
              <Route path="/pos-device-self-service-kiosk">
                {ShowMetaTag("SelfServiceKiosk")}
                <SelfServiceKiosk />
              </Route>
              <Route path="/own-your-online-brand">
                {ShowMetaTag("OwnYourOnlineBrand")}
                <OwnYourOnlineBrand />
              </Route>
              <Route path="/software-solution">
                {ShowMetaTag("SoftwareSolution")}
                <SoftwareSolution />
              </Route>
              <Route path="/software-solution-kiosk">
                {ShowMetaTag("UseCaseKiosk")}
                <KioskSoftwareSolution />
              </Route>
              <Route path="/about-us">
                {ShowMetaTag("AboutUs")}
                <AboutUs />
              </Route>
              <Route path="/acquire-new-customers">
                {ShowMetaTag("AcquireNewCustomers")}
                <AcquireNewCustomers />
              </Route>
              <Route path="/automate-order-process">
                {ShowMetaTag("AutomateOrderProcess")}
                <AutomateOrderProcess />
              </Route>
              <Route path="/bellabot-restaurant-delivery-robot">
                {ShowMetaTag("BellaBot")}
                <BellaBot />
              </Route>
              <Route path="/pricing">
                {ShowMetaTag("Pricing")}
                <Pricing />
              </Route>
              <Route path="/blogs" exact>
                {ShowMetaTag("BlogPage")}
                <BlogPage
                  tagIds={data.tagIds}
                  blogPostList={data.blogPostList}
                  loadBlogPostList={data.loadBlogPostList}
                  pageIndex={data.pageIndex}
                  incrementPageIndex={data.incrementPageIndex}
                  hasNextBlogPosts={data.hasNextBlogPosts}
                  setHasNextBlogPosts={data.setHasNextBlogPosts}
                />
              </Route>
              <Route path="/blogs/:id" exact>
                {ShowMetaTag("BlogPost")}
                <BlogPost
                  tagIds={data.tagIds}
                  blogPost={data.blogPost}
                  getBlogPost={data.getBlogPost}
                  otherBlogPostList={data.otherBlogPostList}
                  getOtherBlogPostList={data.getOtherBlogPostList}
                />
              </Route>
              <Route path="/godigital">
                {ShowMetaTag("GoDigital")}
                <GoDigital />
              </Route>
              <Route path="/techup">
                {ShowMetaTag("TechUp")}
                <TechUp />
              </Route>
              <Route path="/signup">
                {ShowMetaTag("SignUp")}
                <SignUp
                  faqpost_signup_en={data.faqpost_signup_en}
                  faqpost_signup_zh={data.faqpost_signup_zh}
                />
              </Route>
              <Route path="/contact-us">
                {ShowMetaTag("ContactUs")}
                <ContactUs />
              </Route>
              <Route path="/request-a-demo">
                {ShowMetaTag("RequestDemoPage")}
                <RequestDemoPage />
              </Route>
              <Route path="/sitemap">
                {ShowMetaTag("SiteMap")}
                <SiteMap />
              </Route>
              <Route path="/own-your-online-brand">
                {ShowMetaTag("OwnYourOnlineBrand")}
                <OwnYourOnlineBrand />
              </Route>
              <Route path="/hardware-solution">
                {ShowMetaTag("HardwareSolution")}
                <HardwareSolution />
              </Route>
              <Route path="/disinfectionbot-autonomous-disinfection-robot">
                {ShowMetaTag("AutonomousDisinfectionRobot")}
                <AutonomousDisinfectionRobot />
              </Route>
              <Route path="/term-conditions">
                {ShowMetaTag("TermsConditions")}
                <TermsConditions />
              </Route>
              <Route path="/privacy-policy">
                {ShowMetaTag("PrivacyPolicy")}
                <PrivacyPolicy />
              </Route>
              <Route path="/careers">
                {ShowMetaTag("Careers")}
                <Careers />
              </Route>

              <Route path="/clover-application">
                {ShowMetaTag("CloverApplication")}
                <CloverApplication />
              </Route>

              <Route path="/commercial-equipment-leasing">
                {ShowMetaTag("CommercialEquipmentLeasing")}
                <CommercialEquipmentLeasing />
              </Route>

              {data.pages.map((page, index) => {
                return (
                  <Route
                    exact
                    key={index}
                    path={`/${page.slug}`}
                    render={(props) => <ExamplePage {...props} page={page} />}
                  />
                );
              })}
            </Switch>
          </div>
          <ScrollToTop />
          <Footer footer={data.footer} footer2={data.footer2} />
        </IntlProvider>
      </Router>
    </>
  );
  // <Home data={this.props.data} />;
};

const metaTag = {
  Home: {
    title: "Goopter | Digital Ordering Solution For Small Businesses",
  },
  FeaturesBusiness: {
    title:
      "Increase Restaurant Sales with Online Ordering | Goopter Digital Ordering System",
  },
  FeaturesConsumer: {
    title:
      "Online Ordering Features For Consumers | Goopter Digital Ordering System",
  },
  UseCaseRestaurant: {
    title: "Increase Restaurant Sales with Online Ordering | Goopter",
  },
  UseCaseDining: {
    title:
      "Reduce Operational Costs with Dining Automation | Goopter Digital Ordering System",
  },
  UseCaseHotel: {
    title:
      "Automate Room Service For Hotels | Goopter Business Automation Solutions",
  },
  UseCaseRetail: {
    title:
      "Generate More Retail Sales With Online Ordering | Goopter Digital Ordering Solutions",
  },
  UseCaseMovie: {
    title:
      "Eliminate Distractions in Movie Theatres | Goopter Digital Ordering Solution",
  },
  UseCaseCasino: {
    title:
      "Keep the Good Times Going at Casinos | Goopter Digital Ordering Solution",
  },
  UseCaseKiosk: {
    title: "Self-Serve Ordering Kiosk Solution | Goopter",
  },
  FlashBot: {
    title: "FlashBot  | Goopter Hardware Solutions",
  },
  PromoBot: {
    title: "PromoBot  | Goopter Hardware Solutions",
  },
  PuduBot: {
    title: "PuduBot  | Goopter Hardware Solutions",
  },
  Faq: {
    title: "FAQ | Goopter",
  },
  SoftwareSolution: {
    title:
      "Ecommerce Ordering System for Small Businesses | Goopter Digital Ordering System",
  },
  AboutUs: {
    title: "About Us | Goopter",
  },
  AcquireNewCustomers: {
    title: "Acquire New Customers | Goopter Digital Ordering Solutions",
  },
  AutomateOrderProcess: {
    title: "Automate Your Ordering Process | Goopter Digital Ordering System",
  },
  BellaBot: {
    title: "Bellabot  | Goopter Hardware Solutions",
  },
  Pricing: {
    title: "Pricing Options | Goopter",
  },
  BlogPage: {
    title: "Blog Page | Goopter",
  },
  BlogPost: {
    title: "Blog Post | Goopter",
  },
  GoDigital: {
    title: "Grow Your Business Online | Goopter",
  },
  TechUp: {
    title: "Digital Manitoba Initiative - TechUP | Goopter",
  },
  GrantsLandingPage: {
    title: "Canadian Government Grants | Goopter",
  },
  SignUp: {
    title: "Signup | Goopter",
  },
  ContactUs: {
    title: "Contact Us | Goopter",
  },
  RequestDemoPage: {
    title: "Request a free demo | Goopter",
  },
  SiteMap: {
    title: "Sitemap | Goopter",
  },
  OwnYourOnlineBrand: {
    title: "Own Your Online Brand | Goopter",
  },
  HardwareSolution: {
    title: "Delivery and Service Robots | Goopter Hardware Solutions",
  },
  AutonomousDisinfectionRobot: {
    title: "Disinfection Robot  | Goopter Hardware Solutions",
  },
  TermsConditions: {
    title: "Terms & Conditions | Goopter",
  },
  PrivacyPolicy: {
    title: "Privacy Policy | Goopter",
  },
  Careers: {
    title: "Careers | Goopter",
  },
  MerchantService: {
    title: "Merchant Service | Goopter Merchant Service",
  },
  BrowseByUseCases: {
    title: "Browse By Use Cases | Goopter Merchant Service",
  },
  ServiceRate: {
    title: "Service Rate | Goopter Merchant Service",
  },
  CloverFlex: {
    title: "Pos Devices Clover Flex | Goopter POS Device",
  },
  CloverMini: {
    title: "Pos Devices Clover Mini | Goopter POS Device",
  },
  CloverStationDuo: {
    title: "Pos Devices Clover Station Duo | Goopter POS Device",
  },
  CloverStationSolo: {
    title: "Pos Devices Clover Station Solo | Goopter POS Device",
  },
  KitchenDisplaySystem: {
    title: "Pos Devices Kitchen Display System | Goopter POS Device",
  },
  SelfServiceKiosk: {
    title: "Pos Devices Self Service Kiosk | Goopter POS Device",
  },

  CloverApplication: {
    title: "Clover Application | Goopter",
  },

  CommercialEquipmentLeasing: {
    title: "Commercial Equipment Leasing | Goopter Commercial Equipment Leasing",
  }
};

export default Main;
